<!--
 * @Author: PC新模板[mlbb]开始
 * @Date: 2022-12-22 16:28:47
 * @LastEditTime: 2023-11-10 16:26:41
 * @FilePath: /global-coins-moblie/src/pages/Detail/clientType/index_new_pc.vue
 * @developer: yangfan36
-->
<template>
  <div class="new-details-pc-content" :style="pcBackdColor">
    <div class="backdrop" :style="pcBackImg"></div>
    <NEWPcHeader />
    <div class="main">
      <div class="content">
        <div class="lt">
          <NEWPcHeaderCover>
            <NEWBanner class="small-screen" />
          </NEWPcHeaderCover>
          <DetailsUidComponent
            ref="uidRef"
            :addClass="'new-pc-uid-content'"
            v-if="isRenderUid"
          />
          <NEWPackTemplate />
          <NEWReinforcePayment />

          <NewPcCoupon />
          <BottomTips :addClass="'new-pc-bottom-tips'" />
        </div>
        <div
          :class="[
            'rt',
            isRender900Nav ? 'small900' : '',
            isBannerList ? 'banner-exist' : '',
          ]"
          @click.stop
        >
          <client-only>
            <NEWBanner
              class="large-screen"
              @handerBannerList="handerBannerList"
            />
          </client-only>
          <NEWSubmitBtn />
          <ScrollTopCard />
        </div>
      </div>
      <!-- 优惠券登录框start -->
      <CouponEntryForNotLogged :page="gameName" />
      <!-- 优惠券登录框End -->
      <PublicFooter />
      <NEWPcBottomLayer />
      <ScrollTopCard class="small900-card" />
    </div>
  </div>
</template>
<script>
  import CouponEntryForNotLogged from '@/components/CouponEntryForNotLogged'
  import DetailsUidComponent from '@/components/DetailsUidComponent'
  import PublicFooter from '@/components/PublicFooter'
  import NEWPackTemplate from '@/components/NEWPackTemplate'
  import ScrollTopCard from '@/components/ScrollTopCard'
  import NEWPcHeader from '@page_detail/components/NEWPcHeader'
  import NEWPcHeaderCover from '@page_detail/components/NEWPcHeaderCover'
  import BottomTips from '@page_detail/components/BottomTips'
  import NEWPcBottomLayer from '@page_detail/components/NEWPcBottomLayer'
  import NEWBanner from '@page_detail/components/header/Desktop_new'
  import NewPcCoupon from '@page_detail/components/NEWPcCoupon'
  import NEWReinforcePayment from '@page_detail/components/NEWReinforcePayment'
  import NEWSubmitBtn from '@page_detail/components/NEWSubmitBtn'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState } from 'vuex'
  export default {
    name: 'gameDesktop', // pc端游戏详情页
    mixins: [styleConfiguration],
    props: {},
    components: {
      NEWPcHeader,
      NEWPcHeaderCover,
      PublicFooter,
      BottomTips,
      NEWBanner,
      DetailsUidComponent,
      NewPcCoupon,
      CouponEntryForNotLogged,
      ScrollTopCard,
      NEWPcBottomLayer,
      NEWPackTemplate,
      NEWReinforcePayment,
      NEWSubmitBtn,
    },
    data() {
      return {
        discountAmount: 0,
        couponAfterMoney: 0,
        calculatePriceLoading: false,
        isBannerList: false, // banner是否存在
      }
    },
    computed: {
      ...mapState(['gameName']),
      // 当前游戏的全部优惠券
      ...mapState('detail', ['isRender900Nav', 'selectChannelItem']),

      isRenderUid() {
        return this.awardType === 2 || this.uidModuleType === 6
      },
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.dynamicDocStyle()
      },

      handerBannerList(state) {
        this.isBannerList = state
      },

      dynamicDocStyle() {
        if (process.client) {
          document.documentElement.style.width = '100%'
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_new_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './index_new_pc.scss';
  }
  @media (max-width: 1120px) {
    @import './mediaStyles/1120.scss';
  }
  @media (max-width: 900px) {
    @import './mediaStyles/900.scss';
  }
  @media (max-height: 600px) {
    @import './mediaStyles/600.scss';
  }
</style>
